import type { TGlobalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

/**
 * 获取某一类型下当前存在的全部实体 id
 *
 * 从 `VisibleOperation._getUpdateIds` 抽出：隐藏操作需要快照操作当时已存在的全部 id
 */
export const getAllEntityIdsByType = (gs: TGlobalStores, type: EEntityType): string[] => {
  switch (type) {
    case EEntityType.Furniture:
      return gs.modelStore.getFurnitureDatas().map(({ id }) => id);
    case EEntityType.DoorWindow:
      return gs.modelStore.getWindowDatas().map(({ id }) => id);
    case EEntityType.Wall:
      return gs.wallStore.getWallDatas().map(({ id }) => id);
    case EEntityType.Column:
      return gs.structStore.getColumnDatas().map(({ id }) => id);
    case EEntityType.SeparateWall:
      return gs.separateWallStore.separateWallDatas.map(({ id }) => id);
    case EEntityType.Assembly:
      return gs.assemblyStore.getAssemblyDatas().map(({ id }) => id);
    case EEntityType.LinearDimension:
      return gs.dimensionStore.getLinearDimList().map(({ id }) => id);
    case EEntityType.AreaDimension:
      return gs.dimensionStore.getAreaDimList().map(({ id }) => id);
    default:
      return [];
  }
};
